import { Helmet } from "react-helmet-async";

const SITE = "La Console des Artistes";
const DEFAULT_DESC =
  "La Console des Artistes — musiques originales en licence pour vos films, publicités et contenus. Écoutez, licenciez, téléchargez.";

export const SEO = ({ title, description, path = "/", image = null, type = "website" }) => {
  const full = title ? `${title} — ${SITE}` : `${SITE} — La musique qui porte vos images`;
  const desc = description || DEFAULT_DESC;
  const url = `${window.location.origin}${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
    </Helmet>
  );
};
